import styled from "styled-components";
import { useSelector } from 'react-redux'
import { useState,useEffect } from 'react'
import fondo from '../../../imgs/fondo.jpg'
import OptionFilter from '../optionFilter.jsx'
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CambioPrecio from './cambioPrecio.jsx'
import SolicitudesCompra from './solicitudesCompras.jsx'
import DetalleSolicitudCompra from './detalleSolicitudCompra.jsx'
import Backdrop from '@mui/material/Backdrop';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Box from '@mui/material/Box';

const Container=styled.div`
	height:91vh;
	background-image:url(${fondo});
	background-size:cover;
	background-position:center;
	overflow:hiden
	

 `;

const ContainerFiltro=styled.div`
	display:flex;
	justify-content:space-between;
	align-items:center;
	height:60px;
	width:100%;
	background: rgba(1, 1, 1, 0.6);   	
  	backdrop-filter: blur(5px);
 	
  	 
 `;

const ContainerSolicitudes=styled.div`
	height:89%;
	overflow-x:auto;
	width:100%;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px};
	&::-webkit-scrollbar-track{
		background:transparent;		
		border-radius:25px};
	 &::-webkit-scrollbar-thumb {
    background: #27B0FE;
    border-radius: 25px;
  }
	::-webkit-scrollbar:horizontal{display:none}
`;






export default function SolicitudesAdmin(){
 	let solicitudesRedux=useSelector(state=>state.solicitud.solicitudes);
 	let comprasRedux=useSelector(state=>state.solicitudCompras.solicitudCompras);
 	let [ nameFilter,setNameFilter ]=useState("");
 	let [solicitudes,setSolicitudes]=useState([]);
 	let [compras,setCompras]=useState([]);
 	let solicitudesEstado=useSelector(state=>state.solicitud.estadoSolicitud)
 	let [filtro,setFiltro]=useState(0);
 	let [tipo,setTipo]=useState("compra");
 	let items=[{label:"todos",value:0},{label:"pendientes",value:1},{label:"aceptados",value:2},{label:"rechasados",value:3}]
 	const [openState,setOpenState]=useState({compra:{},state:false});
 	

 	useEffect(()=>{
 		if(solicitudesEstado===0&& solicitudesRedux ){
 				let solicitudesTemp=[];
 				let comprasTemp=[];
				switch(filtro){
					case 1:											
						solicitudesRedux.forEach(solicitud=>{
							if(solicitud.pendiente&&solicitud.User.name.toLowerCase().includes(nameFilter.toLowerCase())){
								solicitudesTemp.push(solicitud)
							}
						});

						comprasRedux.forEach(compra=>{
							if(compra.pendiente&&compra.Users[0].name.toLowerCase().includes(nameFilter.toLowerCase())){
								comprasTemp.push(compra)
							}

						});
						setSolicitudes(solicitudesTemp);
						setCompras(comprasTemp);
						break
					case 2:
						solicitudesRedux.forEach(solicitud=>{
							if(solicitud.aceptada&&solicitud.User.name.toLowerCase().includes(nameFilter.toLowerCase())){
								solicitudesTemp.push(solicitud)
								}
						});

						comprasRedux.forEach(compra=>{
							if(compra.aceptada&&compra.Users[0].name.toLowerCase().includes(nameFilter.toLowerCase())){
								comprasTemp.push(compra)
							}

						});
			
						setSolicitudes(solicitudesTemp);
						setCompras(comprasTemp);
						break
					case 3:
						solicitudesRedux.forEach(solicitud=>{
							if(solicitud.aceptada===false&&solicitud.User.name.toLowerCase().includes(nameFilter.toLowerCase())){
								solicitudesTemp.push(solicitud)
								}
						});

						comprasRedux.forEach(compra=>{
							if(compra.rechazada&&compra.Users[0].name.toLowerCase().includes(nameFilter.toLowerCase())){
								comprasTemp.push(compra)
							}

						});
			
						setSolicitudes(solicitudesTemp);
						setCompras(comprasTemp);						
						break
					default:		
						setSolicitudes(solicitudesRedux);
						setCompras(comprasRedux);
						break
					}
 		}

 	},[solicitudesRedux,filtro,solicitudesEstado,comprasRedux,nameFilter])

 	const handleChange = (event, newTipo) => {
    		setTipo(newTipo);
  	};

  	const handleClose=()=>{
  		setOpenState(false)
  	}

 	let hamdleChangeNameFilter=(e)=>{
 		let valor=e.target.value;
 		setNameFilter(valor)
 	}
 	return(
 		<Container>
 			<ContainerFiltro>
 			  	<OptionFilter items={items} label="filtro" setFiltro={setFiltro} />
 			  	<Box sx={{width: 500,maxWidth: '100%',}}    >
      				<TextField fullWidth size="small" label="busca por nombre de usuario"  onChange={hamdleChangeNameFilter}
      				InputProps={{startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment> }}/>
    			</Box>

 			  	<ToggleButtonGroup size="small" exclusive value={tipo}  onChange={handleChange}>
 			  		<ToggleButton value="precio">Cambio Precio</ToggleButton>
      				<ToggleButton value="compra">Solicitud Compra</ToggleButton>
    			</ToggleButtonGroup>

 			</ContainerFiltro>
 			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={openState.state}  > 
		  				
		  				{openState.state?<DetalleSolicitudCompra compra={openState.compra} close={handleClose}/ >:null}
		  				
     	 	</Backdrop>
 			<ContainerSolicitudes>
 				{tipo==="precio"?<CambioPrecio solicitudes={solicitudes}  />:<SolicitudesCompra solicitudes={compras} setOpenState={setOpenState} /> }
 			</ContainerSolicitudes>
 		</Container>


 		)
 }